<template>
  <div>
    <Logo></Logo>
    <!-- <Header/> -->
    <div><img :src="image" class="bg1"></div>


     <div class="box">
        <div class="div_pic">
          <img src="@/assets/join/welcome/joinus.png" class="bg2">
        </div>
    <div class="title">{{lists[0]}}</div>
    <div v-html="list" class="text_box">
        {{list}}
    </div>
     </div>
    <Tabbar></Tabbar>
  </div>
</template>
<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'Join',
  components: {
    // Header,
    Logo,
    Tabbar,
  },
  data () {
    return {
      lists: [
        '拼搏、团结、求实、创新', '通过激光照射烧灼对液晶面板中黑点进行修改的设备通过激光照射烧灼对液晶面板中黑点进行修改的设备通过激光照射烧灼对液晶面板中黑点进行修改的设备通过激光照射烧灼对液晶面板中黑点进行修改的设备通过激光照射烧灼对液晶面板中黑点进行修改的设备。',
        '1111111111', 'zhaopin@bjtstd.com.cn'
      ],
      list: {},
      image: '',
    }
  },
  created () {
    this.local()
  },
  methods: {
    local () {
      var str = window.localStorage
      if (!str) {
        return false
      } else {
        if (str.getItem('welcome')) {
          var welcome = JSON.parse(str.getItem('welcome'))
          if (welcome.image.code === 200) {
            this.image = welcome.image.data.image
          }
          if (welcome.data.code === 200) {
            this.list = welcome.data.data[0].content
          }
          if (new Date().getTime() - welcome.time > 650000) {
            str.removeItem('welcome')
          }
        } else {
          this.getJoin()
        }
      }
    },
    async getJoin () {
      const { data: data } = await api.getJoin()
      const { data: res } = await api.getWelcome()
      var curr = new Date().getTime()
      window.localStorage.setItem('welcome', JSON.stringify({
        time: curr,
        data: res,
        image: data
      }))
      if (data.code === 200) {
        this.image = data.data.image
      }
      if (res.code === 200) {
        this.list = res.data[0].content
      }
    }
  },
}
</script>

<style scoped>
.box {
  margin-left: 1.5rem;
  margin-bottom: 10rem;
}
.title {
  margin-top: 0.75rem;
  color: #428ccb;
  font-size: 2.125rem;
}
.bg1 {
  width: 46.875rem;
  height: 14.75rem;
}
.div_pic{
  width: 100%;

}
.bg2 {
  /* margin-left: 7.8125rem;
  margin-right: 7.8125rem; */
  margin:0 auto;
  width: 100%;
  /* width: 31.25rem; */
  /* height: 31.25rem; */
  margin-top: 4rem;
}
/deep/ .text_box > p {
  margin-top: 2rem !important;
  /* color: #333333 !important; */
  /* font-size: 1.75rem; */
  width: 43.875rem !important;
}
/deep/ p > span {
  color: #333333 !important;
  font-size: 1.75rem !important;
  width: 43.875rem !important;
  margin-top: 2rem !important;
}
</style>
